import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
const API = "https://api.ctexpresskh.com/api";

export default function MobileUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resetModal, setResetModal] = useState(null);
  const [newPwd, setNewPwd] = useState('');
  const token = localStorage.getItem("token");

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(API + "/customer/accounts", { headers: { Authorization: "Bearer " + token } });
      const data = await res.json();
      if (data.success) setUsers(data.data || []);
    } catch {}
    setLoading(false);
  };

  const resetPassword = async () => {
    if (!newPwd || newPwd.length < 6) { alert('Min 6 characters'); return; }
    try {
      const res = await fetch(API + "/customer/admin-reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ phone: resetModal.phone, new_password: newPwd })
      });
      const data = await res.json();
      if (data.success) { toast.success("Password reset!"); setResetModal(null); setNewPwd(''); }
      else toast.error(data.message);
    } catch { toast.error("Error"); }
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>📱 Mobile App Users</h2>
        <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: 13 }}>Customers registered via mobile app — Total: {users.length}</p>
      </div>

      <div style={{ backgroundColor: "#fff", borderRadius: 12, border: "1px solid #e5e7eb", overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f9fafb" }}>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#6b7280" }}>#</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#6b7280" }}>NAME</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#6b7280" }}>PHONE</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#6b7280" }}>CUSTOMER CODE</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#6b7280" }}>REGISTERED</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#6b7280" }}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ textAlign: "center", padding: 40, color: "#6b7280" }}>Loading...</td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: "center", padding: 40, color: "#6b7280" }}>No mobile users yet</td></tr>
            ) : users.map((u, i) => (
              <tr key={u.id} style={{ borderTop: "1px solid #f3f4f6" }}>
                <td style={{ padding: "12px 16px", fontSize: 13, color: "#6b7280" }}>{i + 1}</td>
                <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{u.name}</td>
                <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151" }}>{u.phone}</td>
                <td style={{ padding: "12px 16px" }}>
                  <span style={{ backgroundColor: "#fff7ed", color: "#f97316", fontWeight: 700, fontSize: 12, padding: "3px 10px", borderRadius: 20, border: "1px solid #fed7aa" }}>
                    {u.customer_code || "-"}
                  </span>
                </td>
                <td style={{ padding: "12px 16px", fontSize: 12, color: "#6b7280" }}>
                  {new Date(u.created_at).toLocaleDateString('en-GB')}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  <button onClick={() => { setResetModal(u); setNewPwd(''); }}
                    style={{ backgroundColor: "#dcfce7", color: "#16a34a", border: "none", borderRadius: 6, padding: "6px 12px", cursor: "pointer", fontWeight: 600, fontSize: 12 }}>
                    🔑 Reset PWD
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {resetModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 32, width: 400 }}>
            <h3 style={{ margin: "0 0 8px" }}>🔑 Reset Password</h3>
            <p style={{ margin: "0 0 20px", fontSize: 13, color: "#6b7280" }}>{resetModal.name} ({resetModal.phone})</p>
            <input type="password" placeholder="New password (min 6 chars)" value={newPwd} onChange={e => setNewPwd(e.target.value)}
              style={{ width: "100%", padding: "10px 14px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: "border-box" }} />
            <div style={{ display: "flex", gap: 12 }}>
              <button onClick={() => setResetModal(null)} style={{ flex: 1, padding: 10, border: "1px solid #e2e8f0", borderRadius: 8, cursor: "pointer" }}>Cancel</button>
              <button onClick={resetPassword} style={{ flex: 1, padding: 10, background: "#dc2626", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 700 }}>Reset</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
